/*
 * In this file, all kinds of initializations that vary from project to project are performed.
 */
/**
 * Constants
 */
import { EVENTS } from '@/scripts/constants';

/**
 * Polyfills
 */
import '@/scripts/utils/IIFE/polyfil';
import '@/scripts/utils/IIFE/table-responsive';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';

/**
 * Utils
 */
import { TweenLite, Power1 } from 'gsap/TweenMax';
import PubSub from 'pubsub-js';
import 'EasePack';
import 'ScrollToPlugin';
import LazyLoad from 'vanilla-lazyload';
import NProgress from 'nprogress';
import { loadFonts, sayHello } from '@/scripts/utils';
import 'simplebar';

/**
 * Basic Components
 */
import {
  Preloader,
  VideoModal,
  GalleryModal,
  Form,
  // initCookies,
  // Page navigation + PJAX (BarbaJS)
  PageNavigation,
} from '@/components';


/**
 * Assets
 */
// import '@/fonts';
import 'nprogress/nprogress.css';
import '@/styles/main.scss';

loadFonts(['Muli:400,600,700', 'Montserrat:500,700:latin']);
TweenLite.defaultEase = Power1.easeOut;

// configure progress bar

NProgress.configure({
  minimum: 0.1,
  trickleSpeed: 200,
  showSpinner: false,
});

sayHello();

const initBasics = () => new Promise((resolve) => {
  // set css transition-duration to get it in JS
  const duration = getComputedStyle(document.documentElement)['transition-duration'];
  document.documentElement.dataset.duration = parseFloat(duration);

  // Object fit polyfill
  objectFitImages(); // https://www.npmjs.com/package/object-fit-images
  objectFitVideos(); // https://www.npmjs.com/package/object-fit-videos

  // init cookies bar
  // initCookies();

  // Lazy load images
  // https://github.com/verlok/lazyload
  const lazy = new LazyLoad({
    elements_selector: '[data-lazy-loading="true"]',
    threshold: 1000,
    callback_load() {
      PubSub.publish(EVENTS.lazyImages_imageLoaded);
    },
  });

  PubSub.subscribe(EVENTS.lazyImages_update, () => {
    lazy.update();
  });

  PubSub.subscribe(EVENTS.lazyImages_loadForce, (msg, { lazyImage }) => {
    lazy.load(lazyImage, true);
  });

  resolve(true);
});

const initModals = () => new Promise((resolve) => {
  // init video modal element
  const videoModal = new VideoModal(); // eslint-disable-line no-unused-vars

  const galleryModal = new GalleryModal(); // eslint-disable-line no-unused-vars

  resolve([videoModal, galleryModal]);
});

document.addEventListener('DOMContentLoaded', async () => {
  const pel = document.querySelector('[data-role="preloader"]');
  const preloader = new Preloader({
    element: pel,
  });
  const pageNavigation = new PageNavigation({
    usePJAX: false,
  });
  const app = document.querySelector('.application');
  const shortPreloader = sessionStorage.getItem('shortPreloader') !== null;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        new Form(entry.target);
        observer.unobserve(entry.target);
      }
    });
  });
  document.querySelectorAll('[data-role*="contact-form"]')
    .forEach(el => observer.observe(el));
  if (!shortPreloader) {
    sessionStorage.setItem('shortPreloader', '');
    pel.style.display = 'flex';
    preloader.startLoading();
  }
  // const formsWithCaptcha = document.querySelectorAll('[data-sitekey]');
  // if (formsWithCaptcha.length) {
  //   await new Promise(resolve => setTimeout(resolve, 2500));
  // }
  app.classList.add('application_show');
  if (shortPreloader) {
    preloader.play();
  }
  try {
    const promises = [
      initBasics(),
      initModals(),
      pageNavigation.init(),
    ];
    const coverSliders = document.querySelectorAll('[data-role="cover-slider"]');
    if (coverSliders.length) {
      promises.push(new Promise(resolve => PubSub.subscribe('coverSliderReady', resolve)));
    }
    await Promise.all(promises);
    if (!shortPreloader) {
      preloader.play();
    }
  } catch (e) {
    console.warn(e); // eslint-disable-line
    if (!shortPreloader) {
      preloader.play();
    }
  }
});




// WEBPACK FOOTER //
// ./scripts/common.js